module.exports = __webpack_public_path__ + "img/ic_tripadvisor-5.0.56634d7b.svg";